import React, { FunctionComponent } from 'react';
import { CommercialOffer } from '../../CommercialOffer';
import FreeParticipationBadge from '../../../Purchases/components/FreeParticipationBadge';
import MultiCustomersList from '../../../Purchases/components/MultipleCustomersList';
import ReglamentBadge from '../../../Purchases/components/ReglamentBadge';
import TariffBadge from '../../../Purchases/components/TariffBadge';
import styles from './BadgesList.module.scss';
import { BadgesListProps } from './BadgesList.type';
import SmpBadge from '../../../Purchases/components/SmpBadge';

const BadgesList: FunctionComponent<BadgesListProps> = ({
    announceNumber,
    customers,
    isCommercialOfferVisible,
    isCurrentOrgFreeParticipation,
    isSomeLotSmp,
    procedure,
    tariff,
}) => {
    return (
        <div className={styles.container}>
            <div>
                <ReglamentBadge reglament={procedure?.reglament} />
                <TariffBadge tariff={tariff} />
                <FreeParticipationBadge
                    isCurrentOrgFreeParticipation={
                        isCurrentOrgFreeParticipation
                    }
                />
                <MultiCustomersList
                    hasMultipleCustomers={customers.length > 1}
                    customers={customers}
                />
                {isCommercialOfferVisible && (
                    <CommercialOffer announceNumber={announceNumber} />
                )}
                <SmpBadge isSomeLotSmp={isSomeLotSmp} />
            </div>
        </div>
    );
};

export default React.memo(BadgesList);
